exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ivu-radio-group-button.ivu-radio-group-large .ivu-radio-wrapper[data-v-2b73fba4]{height:32px;line-height:32px;font-size:12px;padding:0px 10px;}\n.ivu-table-cell input[data-v-2b73fba4]{text-align: center;}\n", ""]);

// exports
